import { render, staticRenderFns } from "./Vault.vue?vue&type=template&id=2d625132&"
import script from "./Vault.vue?vue&type=script&lang=js&"
export * from "./Vault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports